// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2DAeR","left":"InfoRow_left__399oc"};